import config from "../../config"
import RequestService from "../RequestService"

const fetchWorkflows = (successCallback, failureCallback) => {
  RequestService.get(`${config.backendUrl}/workflows`, successCallback, failureCallback)
}

export default fetchWorkflows;